<template>
  <fetch-json :url="url">
    <template slot-scope="{ json: documents, loading }">
      <!--<div v-if="loading">Загрузка...</div>
			<div v-else>
				<slot :documents="documents"></slot>
			</div>-->
      <div v-if="!loading"><slot :documents="documents"></slot></div>
    </template>
  </fetch-json>
</template>
<script>
export default {
  props: {
    projectSchema: {
      required: true,
      type: String,
    },
    sectionId: {
      required: true,
      type: String,
    },
    groupKey: {
      required: true,
      type: String,
    },
  },
  computed: {
    url() {
      return `v1/${this.projectSchema}/gisogddocgroupdocs/${this.sectionId}/${this.groupKey}`;
    },
  },
};
</script>
